import { render } from "./productPagePagination.vue?vue&type=template&id=0c25cd5e"
import script from "./productPagePagination.vue?vue&type=script&lang=js"
export * from "./productPagePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__